<div id="app-container" *ngIf="isIframe">
  <header>
    <weaccess-header-navigation></weaccess-header-navigation>
  </header>
  <main class="pt-80" [ngClass]="flag ? 'ps-77 partial-open-sidenav' : 'ps-277 full-open-sidenav'">
    <aside>
      <weaccess-sidebar-navigation (menuToggle)="mainContainerToggle()"></weaccess-sidebar-navigation>
    </aside>
    <router-outlet></router-outlet>
    <weaccess-spinner></weaccess-spinner>
  </main>
  <footer></footer>
</div>